import script from "./ProjectsOverviewDewarmsteweek.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectsOverviewDewarmsteweek.vue?vue&type=script&setup=true&lang=js"

import "./ProjectsOverviewDewarmsteweek.vue?vue&type=style&index=0&id=e5cdbefe&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5cdbefe"]])

export default __exports__